import axiosClient, { app_uri } from "../../../utils/axiosFactory";
import { GciTrackerClient } from "../../../store/repsaApi";
const client = new GciTrackerClient(app_uri, axiosClient());
export default client;
// const baseUrl = `${app_uri}/api/v1/gci-tracker`;

// export const getGciTrackerSettings = async (): Promise<IGciTrackerSettings> => {
//   const response = await axiosClient().get(`${baseUrl}/settings`);
//   return response.data;
// };

// export const updateGciTrackerSettings = async (
//   settings: Partial<IGciTrackerSettings>,
// ): Promise<IGciTrackerSettings> => {
//   const response = await axiosClient().put(`${baseUrl}/settings`, settings);
//   return response.data;
// };

/*
import axiosClient, { app_uri } from "../../../utils/axiosFactory";
import { CommonClient } from "../../../store/repsaApi";

const client = new CommonClient(app_uri, axiosClient());

export default client;

*/
